import { KeyboardKey } from '@this+that/utils';

export enum ShortcutKey {
  // Navigation
  NEXT = 'j',
  PREVIOUS = 'k',
  ARROW_DOWN = KeyboardKey.ARROW_DOWN,
  ARROW_UP = KeyboardKey.ARROW_UP,
  ARROW_LEFT = KeyboardKey.ARROW_LEFT,
  ARROW_RIGHT = KeyboardKey.ARROW_RIGHT,
  OPEN = 'o',
  ENTER = KeyboardKey.ENTER,
  BACK = 'u',

  // Actions
  ARCHIVE = 'e',
  ARCHIVE_ALT = 'y',
  DELETE = '#',
  DELETE_KEY = KeyboardKey.DELETE,
  BACKSPACE = KeyboardKey.BACKSPACE,
  SELECT = 'x',
  SELECT_ALL = 'a',
  MARK_AS_READ = 'i',
  MARK_AS_UNREAD = 'U', // Shift+U
  REPORT_SPAM = '!',
  MOVE_TO_INBOX = 'z',
  MOVE_TO = 'm',

  // Composition
  REPLY = 'r',
  REPLY_ALL = 'a',
  FORWARD = 'f',
  COMPOSE = 'c',

  // DoBox navigation
  HOME = 'Home',
  END = 'End',
  ESCAPE = 'Escape',

  // DoBox actions
  MARK_DONE = 'd',
  ACCEPT_SUGGESTION = 'a',
  OPEN_LABELS = 'l',
  OPEN_PARTICIPANTS = '@',
  OPEN_PRIORITY = 'p',
  OPEN_DUE_DATE_SHIFT = 'D',
  OPEN_CREATE = 'c',
  OPEN_SHORTCUTS_HELP = '?',
  OPEN_TASK_GROUPS = 't',
}

export enum ShortcutContext {
  INBOX_LIST = 'inbox_list',
  INBOX_PREVIEW = 'inbox_preview',
  COMPOSE = 'compose',
  DOBOX = 'dobox',
  DRAFT = 'draft',
  ALL_MAIL = 'all_mail',
  SPAM = 'spam',
  TRASH = 'trash',
  SENT = 'sent',
  SEARCH = 'search',
  SNOOZED = 'snoozed',
  GLOBAL = 'global',
}

export interface ShortcutAction {
  key: ShortcutKey;
  contexts: ShortcutContext[];
  handler: () => void;
  description: string;
  preventDefault?: boolean;
  shiftKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
}

export interface ShortcutConfig {
  key: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
  metaKey?: boolean;
}
